import { State } from "../../../Reducers"
import { OTPSession, UserType } from "../../../Models/Client/User"
import { APIUserModel, UserPlan } from "../../../Models/API/UserModel"

export function getApiKey(state: State): string | undefined {
    const keys = getApiKeys(state)

    return keys.length > 0 ? keys[0] : undefined
}

export function getApiKeys(state: State): string[] {
    if (state.api.authentication.apiKeys.length > 0)
        return state.api.authentication.apiKeys

    return []
}

export function selectUser(state: State): APIUserModel | undefined {
    return state.api.authentication.user ?? undefined
}

export function getEmail(state: State): string | undefined {
    return state.api.authentication.user?.email
}

export function selectUserId(state: State): string | undefined {
    return state.api.authentication.user?.id
}

export function selectUserName(state: State): string | undefined {
    return state.api.authentication.user?.username
}

export function isAuthenticated(state: State): boolean {
    return state.auth.user.type === UserType.member
}

export function isAuthenticatedOrResumingSession(state: State): boolean {
    return (
        isAuthenticated(state) ||
        (state.auth.user.type === UserType.unresolved &&
            state.auth.user.isResumingSession)
    )
}

export function isAuthTransitioning(state: State): boolean {
    const user = state.auth.user

    return (
        user.type === UserType.unresolved ||
        (user.type === UserType.member && user.isSigningOut) ||
        (user.type === UserType.anonymous &&
            (user.isSigningIn || user.isSigningUp))
    )
}

export function isSignedOutOrSigningOut(state: State): boolean {
    const user = state.auth.user

    return (
        (user.type === UserType.anonymous &&
            !user.isSigningIn &&
            !user.isSigningUp) ||
        (user.type === UserType.member && user.isSigningOut)
    )
}

export function selectIsSysAdmin(state: State): boolean {
    return state.api.authentication.user?.groups?.includes("SYSADMIN") ?? false
}

export function selectIsSysCrowdManager(state: State): boolean {
    return (
        state.api.authentication.user?.groups?.includes("SYSCROWDMANAGER") ??
        false
    )
}

export function isUserResolve(state: State): boolean {
    return (
        state.auth.user.type === UserType.anonymous ||
        (state.auth.user.type === UserType.member &&
            state.api.authentication.apiKeys.length > 0)
    )
}

export function isFullPlanUser(state: State): boolean {
    return (
        isAuthenticated(state) &&
        state.api.authentication.user?.plan === UserPlan.FULL
    )
}

export function selectHasFreemiumExpired(state: State): boolean {
    return state.api.authentication.freemiumPlanExpiryDays === 0
}

export function selectFreemiumPlanExpiryDays(state: State): number | undefined {
    return state.api.authentication.freemiumPlanExpiryDays
}

export function selectCurrentUserSession(state: State): OTPSession | undefined {
    const user = state.auth.user
    return user.type === UserType.anonymous ? user.session : undefined
}
